import React, { useRef } from "react";
import { motion, useInView, useReducedMotion } from "framer-motion";

import { cn } from "@/lib/utils";

type RevealOnScrollProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: "div" | "section";
};

export function RevealOnScroll({
  children,
  className,
  delay = 0,
  as = "div",
}: RevealOnScrollProps) {
  const ref = useRef<HTMLElement | null>(null);
  const prefersReducedMotion = useReducedMotion();
  const isInView = useInView(ref, { once: true, margin: "-12% 0px" });

  const initialState = prefersReducedMotion
    ? { opacity: 1, y: 0 }
    : { opacity: 0, y: 32 };
  const animateState = prefersReducedMotion
    ? { opacity: 1, y: 0 }
    : isInView
    ? { opacity: 1, y: 0 }
    : { opacity: 0, y: 32 };

  const Component = as === "section" ? motion.section : motion.div;

  return (
    <Component
      ref={ref as React.Ref<HTMLElement>}
      className={cn("will-change-transform", className)}
      initial={initialState}
      animate={animateState}
      transition={{ duration: 0.6, delay: prefersReducedMotion ? 0 : delay, ease: [0.21, 0.47, 0.32, 0.98] }}
    >
      {children}
    </Component>
  );
}

export default RevealOnScroll;
